import { TimeIntervalType } from '../types/TimeIntervalType';

export class TimeInterval {
  public readonly days: number;

  constructor(public readonly type: TimeIntervalType) {
    this.days = this.getTimeIntervalInDays(this.type);
  }

  private getTimeIntervalInDays(type: TimeIntervalType): number {
    if (type === TimeIntervalType.TODAY) return 1;
    if (type === TimeIntervalType.THIS_WEEK) return 7;
    if (type === TimeIntervalType.THIS_MONTH) return 30;
    throw new Error('Invalid time interval type');
  }

  public isLower(timeInterval: TimeInterval): boolean {
    return this.days < timeInterval.days;
  }
}
